<script setup lang="ts">
import { useThemeStore, getTheme } from "@/stores/theme";
import { computed } from "vue";

const Component = computed(() => getTheme(themeStore.theme).component);

const themeStore = useThemeStore();
</script>

<template>
  <div>
    <Component />
  </div>
</template>
